import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const CallToAction = ({ theme }) => {
  // --- ADDED MOBILE STATE ---
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // --- ADDED EMAIL HANDLER ---
  const handleEmailClick = () => {
    window.location.href = 'mailto:sales@siteact.app';
  };

  return (
    <section style={{ 
      padding: isMobile ? '60px 20px' : '100px 20px', // Responsive padding
      background: `linear-gradient(135deg, ${theme.primary} 0%, ${theme.primaryDark || '#1e40af'} 100%)`,
      textAlign: 'center',
      color: 'white'
    }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h2 style={{ fontSize: isMobile ? '2rem' : '2.5rem', fontWeight: '800', marginBottom: '20px' }}>
          Ready to replace your paperwork?
        </h2>
        <p style={{ fontSize: isMobile ? '1.05rem' : '1.25rem', marginBottom: '40px', opacity: 0.9 }}>
          Join the builders who have switched to SiteACT. Setup takes 15 minutes. No credit card required for the demo or free trial.
        </p>
        
        <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button 
            onClick={handleEmailClick} // <-- TRIGGER EMAIL
            style={{ 
              padding: '18px 36px', borderRadius: '8px', border: 'none', 
              background: 'white', color: theme.primary, 
              fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer',
              width: isMobile ? '100%' : 'auto' // Full width on mobile
            }}>
            Start Free Trial
          </button>
          
          <button 
            onClick={handleEmailClick} // <-- TRIGGER EMAIL
            style={{ 
              padding: '18px 36px', borderRadius: '8px', border: '2px solid rgba(255,255,255,0.3)', 
              background: 'transparent', color: 'white', 
              fontSize: '1.1rem', fontWeight: 'bold', cursor: 'pointer',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px',
              width: isMobile ? '100%' : 'auto' // Full width on mobile
            }}>
            Talk to Sales <ArrowRight size={20} />
          </button>
        </div>

        <p style={{ marginTop: '20px', fontSize: '0.9rem', opacity: 0.7 }}>
          Includes 30-day money-back guarantee.
        </p>
      </div>
    </section>
  );
};

export default CallToAction;